<div class="inspection-screening-popup grey" >
  <div class="modal-header" style="border-bottom: none;">
    <div>
      <h5 class="modal-title fw-bold mb-1">{{agentName ? agentName : 'Unassigned'}}</h5>
      <div class="text-secondary text-uppercase">
        {{ userType === 'cargo_agent' ? ('batches.cargoagent' | cxTranslate) : userType === 'inspection_agent' ? ('batches.inspection_agent' | cxTranslate) : ('batches.screening_operator' | cxTranslate) }}
      </div>
    </div>
    <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body grey">
    <div class="card border-radius-05 shadow-sm" style="background: #fff;">
      <div class="card-body p-0">
        <div class="table-responsive">
          <table class="table table-hover mb-0">
            <thead>
              <tr>
                <th scope="col" class="text-black">{{'batches.contact' | cxTranslate}}</th>
                <th scope="col" class="text-black">{{'batches.email' | cxTranslate}}</th>
                <th scope="col" class="text-black">{{'batches.mobile' | cxTranslate}}</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let member of cargoAgentMembers">
                <td>{{member?.firstName ? member?.firstName : '--'}} {{member?.lastName ? member?.lastName : '--'}}</td>
                <td>{{member?.email ? member?.email : '--'}}</td>
                <td>{{member?.mobileNumber ? member?.mobileNumber : '--'}}</td>
              </tr>
              <tr *ngIf="!cargoAgentMembers || cargoAgentMembers.length === 0">
                <td colspan="3" class="text-center text-secondary strong py-3">No results</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>
